module.exports = __webpack_public_path__ + "img/jypx-1.e4b50ba3.webp";